'use strict';
var base = require('./base');
var Carousel = require('../components/carousel');

/**
 * Handles unslicking the carousel and removing the bootstrap modal
 * @param {Object} el - the carousel element
 */
function handleUnslickAndRemoveModal(el) {
    if (el.hasClass('slick-initialized')) {
        el.slick('unslick');
    }
    $('#image-zoom-modal').modal('hide');
}

/**
 * Registers medium browser width with enquire.
 * When width is greater than medium, the carousel is activated.
 * When the width is less than medium, the carousel element is unslicked and the zoom modal is removed.
 * @param {Object} carousel - the carousel object
 */
function handleBrowserWidth(carousel) {
    enquire.register('screen and (min-width: ' + (globalConfig.bp.medium + 1) + 'px)', {
        match: function () {
            if (!carousel.$element.hasClass('slick-initialized')) {
                carousel.activate();
            }
        },
        unmatch: function () {
            handleUnslickAndRemoveModal(carousel.$element);
        }
    });
}

/**
 * Inits the image zoom carousel, passes carousel to handleBrowserWidth
 */
function initImageZoomCarousel() {
    var $imageZoomCarousel = new Carousel('imageZoomCarousel');
    handleBrowserWidth($imageZoomCarousel);
}

/**
 * registers handleUnslickAndRemoveModal to zoom-close click event
 */
function initZoomRemove() {
    $('#zoom-close').on('click', function () {
        handleUnslickAndRemoveModal($('.image-zoom'));
    });
}

/**
 * Manually builds the first Product-Variation url for View Details button so that all attributes are included
 * @param {string} variantUrl - url for Product-Variation Ajax call - if left off, select first option for each variationAttribute
 */
function callProductVariant(variantUrl) {
    var url;
    var $productContainer = $('.variation-attribute:visible').first().closest('.set-item');
    if (!$productContainer.length) {
        $productContainer = $('.variation-attribute:visible').first().closest('.details-view');
    }

    if (variantUrl && variantUrl !== null && variantUrl !== undefined) {
        // Call for specified variant
        url = variantUrl;
    } else {
        // Build url based on first selection from each variationAttribute

        // get url from first variationAttribute value's button and extract base pipeline url
        var buttonUrl = $('.variation-attribute:visible').find('.attribute button').first().data('url');
        var baseUrl = buttonUrl.substring(0, buttonUrl.indexOf('?'));

        // get pid from buttonUrl
        var pidStartIdx = buttonUrl.indexOf('pid=');
        var pidSubstr = buttonUrl.substring(pidStartIdx);
        var pid = pidSubstr.substring(4, pidSubstr.indexOf('&'));

        // select value for each variationAttribute
        var varString = $('.variation-attribute:visible').map(function () {
            return 'dwvar_double-arm-beldi_' + $(this).data('attr') + '=' + $(this).find('.attribute button').first()
                .find('.selectable')
                .data('attr-value');
        }).toArray().join('&');

        // combine into url for ajax call
        url = baseUrl + '?' + varString + '&pid=' + pid + '&quantity=1';
    }

    // call Product-Variation ajax using frontend flow from base so that page data is updated correctly
    base.attributeSelect(url, $productContainer);
}

/**
 * Auto-plays active lifestyle gallery modal video or iframe on navigate
 */
function autoPlayLifestyleModalContent() {
    $('.lifestyle-gallery-modal .slick-active.slick-current video').each(function () {
        $(this).get(0).play();
    });

    $('.lifestyle-gallery-modal .slick-active.slick-current iframe').each(function () {
        $(this).attr('src', $(this).attr('src') + '&autoplay=1');
    });
}

/**
 * Stops iframe or video playing on carousel navigate
 */
function stopAutoPlayingContent() {
    $('.lifestyle-gallery-modal video').each(function () {
        $(this).get(0).pause();
    });

    $('.lifestyle-gallery-modal iframe').each(function () {
        $(this).attr('src', $(this).attr('src').replace('&autoplay=1', ''));
    });
}

module.exports = {
    initBase: function () {
        base.selectAttribute();
        base.colorAttribute();
        base.variantAttribute();
        base.removeBonusProduct();
        base.selectBonusProduct();
        base.enableBonusProductSelection();
        base.showMoreBonusProducts();
        base.addBonusProductsToCart();
        base.focusChooseBonusProductModal();
        base.trapChooseBonusProductModalFocus();
        base.onClosingChooseBonusProductModal();
    },
    availability: base.availability,
    addToCart: base.addToCart,
    initCarousel: base.initCarousel,
    initBundleCarousel: base.initBundleCarousel,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    autoShowPDP: function () {
        // This will auto-display the "View Details" page if a sku is supplied in the Product-Show url params
        $(document).ready(function () {
            if ($('.view-details').data('show-on-load') === true) {
                $('.ctas .view-details').trigger('click');
            }
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
                response.container.find('.product-sku').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);

            // Logic for applePay from CyberSource cartridge
            if (SitePreferences.CS_ENABLED) {
                if (response.product.readyToOrder) {
                    var applePayButton = $('.apple-pay-pdp', response.$productContainer);
                    if (applePayButton.length !== 0) {
                        applePayButton.attr('sku', response.product.id);
                    } else {
                        if ($('.apple-pay-pdp').length === 0) { // eslint-disable-line no-lonely-if
                            $('.cart-and-ipay').append('<isapplepay class="apple-pay-pdp btn"' +
                                'sku=' + response.product.id + '></isapplepay>');
                        }
                    }
                } else {
                    $('.apple-pay-pdp').remove();
                }
            }
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    if ($('#sizeChartModal').length !== 0) {
                        $('#sizeChartModal').remove();
                    }

                    var htmlString = '<!-- Modal -->'
                        + '<div class="modal fade" id="sizeChartModal" role="dialog">'
                        + '<div class="modal-dialog">'
                        + '<!-- Modal content-->'
                        + '<div class="modal-content">'
                        + '<div class="modal-header">'
                        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
                        + '        &times;'
                        + '    </button>'
                        + '</div>'
                        + '<div class="modal-body">' + data.content + '</div>'
                        + '<div class="modal-footer"></div>'
                        + '</div>'
                        + '</div>'
                        + '</div>';

                    $('body').append(htmlString);
                    $('#sizeChartModal').modal('show');
                }
            });
        });
    },
    zoomModal: function () {
        $(document).on('click', '.icon-pdp-zoom', function () {
            initZoomRemove();
            $('#image-zoom-modal').modal('show');
            $('#image-zoom-modal').on('shown.bs.modal', function () {
                initImageZoomCarousel();
            });
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, globalConfig.toastTimeout);
        });
    },

    openShareModal: function () {
        $('.product-wrapper .icon-share').on('click', function () {
            // in certain scenarios the modal background (which is used for my account / mini cart as well) is already visible
            // we only want to show it on 320 for the share modal
            if ($('.modal-background').is(':visible')) {
                $('.modal-background').hide();
            }
            $('.product-share-modal').removeClass('d-none');
            enquire.register('screen and (max-width: ' + (globalConfig.bp.xxsmall + 1) + 'px)', {
                match: function () {
                    $('.modal-background').show();
                }
            });
        });
    },

    closeShareModal: function () {
        var container = $('.product-share-modal');

        $('.product-share-modal .icon-close').on('click', function () {
            container.addClass('d-none');
            enquire.register('screen and (max-width: ' + (globalConfig.bp.xxsmall + 1) + 'px)', {
                match: function () {
                    $('.modal-background').hide();
                }
            });
        });

        $(document).on('click', function (e) {
            // if the target of the click isn't the container
            // nor a descendant of the container
            // nor the share icon
            // and the container isn't already hid
            if (!container.is(e.target)
                && container.has(e.target).length === 0
                && !$(e.target).hasClass('icon-share')
                && !container.hasClass('d-none')) {
                enquire.register('screen and (max-width: ' + (globalConfig.bp.xxsmall + 1) + 'px)', {
                    match: function () {
                        $('.modal-background').hide();
                    }
                });
                container.addClass('d-none');
            }
        });
    },

    scrollToSection: function () {
        var scrollIt = function () {
            var position = $('.lifestyle-gallery').offset().top - $('.header.container').height() - 50;
            $('html, body').animate({
                scrollTop: position
            }, 500);
        };

        $(document).on('click', '.view-gallery', function () {
            scrollIt();
        });

        $(document).on('click', '.view-gallery-mobile', function () {
            scrollIt();
        });
    },

    openLifestyleModal: function () {
        var pdpLifeStyleGalleryIndex = 0;
        var $lifestyleImageModalCarousel = new Carousel('pdpLifestyleGalleryModalCarousel');

        $('#lifestyle-gallery-modal').on('shown.bs.modal', function () {
            $lifestyleImageModalCarousel.setConfig({ initialSlide: pdpLifeStyleGalleryIndex });
            $lifestyleImageModalCarousel.activate();
            $(window).on('resize', function () {
                $('.lifestyle-gallery-modal').slick('refresh');
            });

            autoPlayLifestyleModalContent();
        });

        $('#lifestyle-gallery-modal').on('hidden.bs.modal', function () {
            $('.lifestyle-gallery-modal').slick('unslick');
            $(window).off('resize');

            stopAutoPlayingContent();
        });

        $('#pdp-lifestyle-gallery .gallery-slide').on('click', function () {
            pdpLifeStyleGalleryIndex = $(this).data('slickIndex');
            $('#lifestyle-gallery-modal').modal('show');
            $('.lifestyle-gallery-modal').find('.slick-list').attr('tabindex', 0).focus();
        });
    },

    openDetailsView: function () {
        $('.ctas .view-details').on('click', function () {
            $('.details-view').removeClass('d-none');
            callProductVariant($(this).data('default-variation-url'));
            $('.top-content').addClass('d-none');
            $('.additional-images').addClass('d-none');
            $('.lifestyle-gallery').addClass('d-none');
            $('.recommendations').addClass('d-none');
            $('.einstein-pdp-recommendations').addClass('d-none');
            $('.product-breadcrumb').addClass('d-none');
            // scroll to top
            $('html, body').animate({
                scrollTop: $('.lifestyle-gallery').offset().top - $('.header.container').height() - 50
            }, 500);
        });
    },

    closeDetailsView: function () {
        $('.details-view .icon-close').on('click', function () {
            $('.details-view').addClass('d-none');
            $('.top-content').removeClass('d-none');
            $('.additional-images').removeClass('d-none');
            $('.lifestyle-gallery').removeClass('d-none');
            $('.recommendations').removeClass('d-none');
            $('.einstein-pdp-recommendations').removeClass('d-none');
            $('.product-breadcrumb').removeClass('d-none');
            $('.carousel.main').slick('setPosition');
        });
        $(document).keydown(function (e) {
            if (e.keyCode === 27) {
                $('.details-view').addClass('d-none');
                $('.top-content').removeClass('d-none');
                $('.additional-images').removeClass('d-none');
                $('.lifestyle-gallery').removeClass('d-none');
                $('.recommendations').removeClass('d-none');
                $('.product-breadcrumb').removeClass('d-none');
                $('.carousel.main').slick('setPosition');
            }
        });
    },

    pauseVideo: function () {
        $(document).on('click', '.slick-arrow', function () {
            var slickActive = $(this).siblings('.slick-list').find('.slick-active');
            // unmount the video of the previous slide if going forward
            if (slickActive.prev().children('iframe')) {
                var prev = slickActive.prev().children('iframe');
                var prevSrc = prev.attr('src');
                prev.removeAttr('src');
                prev.attr('src', prevSrc);
            }
            // unmount the video of the previous slide if going backward
            if (slickActive.next().children('iframe')) {
                var next = slickActive.next().children('iframe');
                var nextSrc = next.attr('src');
                next.removeAttr('src');
                next.attr('src', nextSrc);
            }
        });

        $(document).on('click', '.lifestyle-gallery-modal.slick-initialized button', function () {
            stopAutoPlayingContent();
            autoPlayLifestyleModalContent();
        });

        $(document).on('click', '.icon-close', function () {
            // unmount the video of current slide if clicking x
            var slickActive = $('.lifestyle-gallery-modal').find('.slick-active');
            var active = slickActive.children('iframe');
            if (active) {
                var activeSrc = active.attr('src');
                active.removeAttr('src');
                active.attr('src', activeSrc);
            }
        });

        $(document).on('click', function (e) {
            var container = $('.modal-content');

            if (!container.is(e.target) && container.has(e.target).length === 0) {
                var slickActive = $('.lifestyle-gallery-modal').find('.slick-active');
                var active = slickActive.children('iframe');
                if (active) {
                    var activeSrc = active.attr('src');
                    active.removeAttr('src');
                    active.attr('src', activeSrc);
                }
            }
        });
    },

    handlePDPZoom: function () {
        var enableZoom = function () {
            if (!$('.product-detail').hasClass('pdp-image-zoom')) {
                $('.product-detail').toggleClass('pdp-image-zoom');
                $('.carousel.main').slick('setPosition');
            }
        };

        $('.primary-images-pdp button').on('click', function (e) {
            e.stopPropagation();
        });
        $('.primary-images-pdp img').not('button').not('pdp-close').on('click', function () {
            enableZoom();
        });
        $('.pdp-standard-image-container img').not('button').not('pdp-close').on('click', function () {
            enableZoom();
        });
        $('.pdp-close').on('click', function () {
            if ($('.product-detail').hasClass('pdp-image-zoom')) {
                $('.product-detail').removeClass('pdp-image-zoom');
                $('.carousel.main').slick('setPosition');
            }
        });
    },

    loginModal: function () {
        $('body').on('click', '.add-tocart-login-modal', function (e) {
            e.preventDefault();
            $('body').trigger('display:loginModal');
        });
    },

    handleSampleModal: function () {
        $('body').on('click', '.open-sample-modal', function (e) {
            e.preventDefault();

            $('#sampleModal').modal('show');
            $('#sampleModal').find('select').trigger('change');
        });
    },

    breadcrumbsEvents: function () {
        $('.breadcrumb-trigger').on('mouseenter', function () {
            $(this).find('.breadcrumb-hover-dropdown').removeClass('d-none');
        });

        $('.breadcrumb-trigger').on('mouseleave', function () {
            $(this).find('.breadcrumb-hover-dropdown').addClass('d-none');
        });

        $('.breadcrumb-hide-dropdown').on('click', function (e) {
            e.preventDefault();

            $(this).closest('.breadcrumb-hover-dropdown').addClass('d-none');
        });
    },

    initEinsteinMutationObserver: function () {
        // Find Einstein recommendations container.
        var target = document.querySelector('.einstein-pdp-recommendations');
        // If container exists, add logic to lazy load images.
        if (target) {
            // Revalidate lazy loaded images before adding observer to ensure no gaps.
            $(document).trigger('blazy:revalidate');
            // Create mututation observer to kick off lazy load event.
            var observer = new MutationObserver(function () {
                // Lazy load images if not already loaded.
                $(document).trigger('blazy:revalidate');
            });
            // Target subtree modifications to Einstein recommendations only.
            observer.observe(target, { childList: true, subtree: true });
        }
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    waitForImagesInit: base.waitForImagesInit(),
    loadSpec: base.loadSpecifications(),
    updateAddToCartBtn: base.updateAddToCartBtn()
};
